import React from "react";
import { Outlet } from "react-router-dom";
import Page from "../../components/Page";
import Header from "../dashboard/Header";
import MainFooter from "../main/MainFooter";
import SideBar from "./SideBar";
import MainNavbar from "../main/MainNavbar";
import LoanHeader from "./LoanHeader";

export default function LoanLayout() {
  return (
    <>
      <LoanHeader />
      <Page title="Loan">
        <section id="vendor_area" className="ptb-50">
          <div className="container-fluid">
            <div className="row">
              <SideBar />
              <div className="col-sm-12 col-md-12 col-lg-9">
                <div className="vendor_dashboard">
                  <Outlet />
                </div>
              </div>
            </div>
          </div>
        </section>
        <MainFooter />
      </Page>
    </>
  );
}
